import nxtoperations from './nxtoperations';
import ntxdemand from './nxtdemand';

const themeOptions = {
  nxtoperations,
  ntxdemand,
};

export default themeName => themeOptions[themeName];
